<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table ref="xzTable" :columns="columnLists" :data="data" :searchAttrs="searchAttrs"
            :searchVal.sync="outform.name" :toolsAttrs="toolsAttrs" :drawerVisible.sync="drawerVisible"
            :scroll="{ x: '100%', y: scrollHeight }" :drawerWidth="460" @search="() => handleOutChange()" rowKey="id"
            @refresh="handleReset" @fullScreen="handleFullScreen" class="wrap">
            <template #drawer>
              <div style="flex: 1; overflow: auto" class="advanced-search">
                <a-form-model :model="form" ref="searchRef" :label-col="labelCol" :wrapper-col="wrapperCol" :colon="false">
                  <a-form-model-item label="适用客户">
                    <a-input v-model="form.applyCustomer" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                </a-form-model>
              </div>
              <div style="text-align: right; height: 68px; line-height: 68px">
                <a-button @click="handleEmpty">
                  重置
                </a-button>
                <a-button type="primary" style="margin-left: 10px;" @click="handleAdvancedQuery">
                  确定
                </a-button>
              </div>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="goodsConnectManagement" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <template slot="action">
              <el-button @click="handleAction" type="text">查看</el-button>
            </template>
          </xz-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { goodsPriceTemplate } from '@/api/goods';

const COMMON_COLUMNS = [
  {
    title: '商品定价模板',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '适用客户',
    dataIndex: 'applyCustomer',
    key: 'applyCustomer',
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '模板备注',
    dataIndex: 'remark',
    key: 'remark',
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
];

export default {
  name: 'GOODSCONNECT',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      data: [],
      outform: {
        name: '',
      },
      form: {
        applyCustomer: '',
      },
      total: 0,
      searchAttrs: {
        show: true,
        placeholder: '请输入商品定价模板',
        data: 'name',
      },
      drawerVisible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      page: {
        pageSize: 10,
        pageNum: 1,
      },
      scrollHeight: 600,
      isFullScreen: false,
    };
  },
  methods: {
    updateColumnList (columnList) {
      this.columnLists = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    handleAdvancedQuery () {
      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleReset () {
      this.outform = this.$options.data().outform;
      this.form = this.$options.data().form;
      this.page.pageNum = 1;
      this.page.pageSize = 10;

      this.handleSearch();
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;

      this.handleSearch();
    },
    handleNumChange (num) {
      this.page.pageNum = num;

      this.handleSearch();
    },
    handleAction () {
      this.$router.push({
        path: '/VIS/product',
      });
    },
    async handleSearch () {
      this.data = [];
      const { body } = await goodsPriceTemplate({
        ...this.outform,
        ...this.form,
        ...this.page,
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'DESC',
        }],
      });

      this.data = body?.list || [];

      this.total = +body?.total || 0;

      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },
    handleOutChange (key, o) {
      if (key) {
        this.outform[key] = o.value;
      }

      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
  },
  mounted () {
    this.handleSearch();
  },
};
</script>
<style scoped lang="scss">
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}

.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 14px;
        font-weight: 600;
        padding-right: 2em;
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #F2F4F7;

          &.active-radio {
            border-color: #E2F3FE;
            background-color: #E2F3FE;
            color: #237FFA;
          }
        }
      }
      .table-wrapper.fullscreen {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0px;
        z-index: 100;
        background: #FFFFFF;
      }
    }
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #C9CED6;
  background: #C9CED6;
}
</style>
